module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Thin-WebS-b68b4bee2dcc82967c7f4cd71b2513c3.woff2";